"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GateEvaluateCommand = void 0;
const clipanion_1 = require("clipanion");
const plugin_1 = require("@datadog/datadog-ci-base/helpers/plugin");
const validation = __importStar(require("@datadog/datadog-ci-base/helpers/validation"));
const __1 = require("../..");
class GateEvaluateCommand extends __1.BaseCommand {
    constructor() {
        super(...arguments);
        this.dryRun = clipanion_1.Option.Boolean('--dry-run', false);
        this.failOnEmpty = clipanion_1.Option.Boolean('--fail-on-empty', false);
        this.failIfUnavailable = clipanion_1.Option.Boolean('--fail-if-unavailable', false);
        this.noWait = clipanion_1.Option.Boolean('--no-wait', false);
        this.timeoutInSeconds = clipanion_1.Option.String('--timeout', '600', {
            validator: validation.isInteger(),
        });
        this.userScope = clipanion_1.Option.Array('--scope');
        this.tags = clipanion_1.Option.Array('--tags');
        this.fips = clipanion_1.Option.Boolean('--fips', false);
        this.fipsIgnoreError = clipanion_1.Option.Boolean('--fips-ignore-error', false);
    }
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, plugin_1.executePluginCommand)(this);
        });
    }
}
exports.GateEvaluateCommand = GateEvaluateCommand;
GateEvaluateCommand.paths = [['gate', 'evaluate']];
GateEvaluateCommand.usage = clipanion_1.Command.Usage({
    category: 'CI Visibility',
    description: 'Evaluate Quality Gates rules in Datadog.',
    details: `
      This command will evaluate the matching quality gate rules in Datadog.\n
      See README for details.
    `,
    examples: [
        ['Evaluate matching quality gate rules in Datadog', 'datadog-ci gate evaluate'],
        [
            'Evaluate matching quality gate rules in Datadog, failing if no rules were found',
            'datadog-ci gate evaluate --fail-on-empty',
        ],
        [
            'Evaluate matching quality gate rules in Datadog, failing if Datadog is not available',
            'datadog-ci gate evaluate --fail-if-unavailable',
        ],
        [
            'Evaluate matching quality gate rules in Datadog and add extra scope',
            'datadog-ci gate evaluate --scope team:backend',
        ],
        [
            'Evaluate matching quality gate rules in Datadog and add extra tags',
            'datadog-ci gate evaluate --tags team:frontend',
        ],
        [
            'Evaluate matching quality gate rules in Datadog from the datadoghq.eu site',
            'DD_SITE=datadoghq.eu datadog-ci gate evaluate',
        ],
        [
            'Evaluate matching quality gate rules in Datadog with a timeout of 120 seconds',
            'datadog-ci gate evaluate --timeout 120',
        ],
        ['Evaluate matching quality gate rules in Datadog without waiting', 'datadog-ci gate evaluate --no-wait'],
    ],
});
//# sourceMappingURL=evaluate.js.map